import O1HD from "../../../engines/gameEngine";
import {BUNDLE_SMALL_NAME, getOneBundleOnePrefab} from "../BundleResourceConfig";
import NormalGameManager from "../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class EnterMineralNode extends cc.Component {



    onLoad () {}

    start () {

    }

    /**
     * 取消
     */
    onBtnCancel(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._close();
    }

    /**
     * 进入
     */
    async onBtnPayEnter(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( O1HD.getServices().userSrv.getCoins() < 2000 ) {
            NormalGameManager._instance.openBankPage();
            O1HD.getModules().uiControlModule.showMessageBox("您的资金不足");
            return;
        }
        O1HD.getServices().userSrv.setCoins( -2000 , true );
        let url = "prefab/mineLandNode";
        let prefab = await getOneBundleOnePrefab( BUNDLE_SMALL_NAME.mineLandGameBundle , url );
        let mineLandPrefab = cc.instantiate(prefab);
        O1HD.Canvas().addChild( mineLandPrefab );
        this._close();
    }



    private _close(){
        this.node.removeFromParent();
        this.node.destroy();
    }

}
